import { MigrationFunction } from "../types";
import { migrateBgNames } from "./migrateBgNames";
import { migrateCharABC } from "./migrateCharABC";
import { migrateCharPos } from "./migrateCharPos";
import { migrateCleanUpCamera } from "./migrateCleanUpCamera";
import { migrateDialogCharacters } from "./migrateDialogCharacters";
import { migrateFixStepNavigation } from "./migrateFixStepNavigation";
import { migrateFixUnlinkedSteps } from "./migrateFixUnlinkedSteps";
import { migrateGestureAnimation } from "./migrateGestureAnimation";
import { migrateNewSchema } from "./migrateNewSchema";
import { migratePerStepBackgrounds } from "./migratePerStepBackgrounds";
import { migrateRevertCharPos } from "./migrateRevertCharPos";
import { migrateStepNavigation } from "./migrateStepNavigation";
import { migrateToTimelines } from "./migrateToTimelines";

export const migrations: Record<number | string, MigrationFunction> = {
  1: migrateStepNavigation,
  2: migrateDialogCharacters,
  3: migratePerStepBackgrounds,
  4: migrateFixStepNavigation,
  5: migrateCleanUpCamera,
  6: migrateNewSchema,
  7: migrateCharABC,
  8: migrateCharPos,
  9: migrateRevertCharPos,
  10: migrateFixUnlinkedSteps, // We only fixed the issue that caused the unlink steps now, so we need to run this migration again
  11: migrateBgNames,
  12: migrateGestureAnimation,
  13: migrateToTimelines,
}

const migrationVersions = Object.keys(migrations).sort((a, b) => Number(a) - Number(b));

export const lastMigrationVersion = Number(migrationVersions[migrationVersions.length-1]);
